import React from "react";
import { Link } from "react-router-dom";
import { heroData, stats, products, features } from "../mock";
import { ArrowRight, ChevronDown } from "lucide-react";

export default function Home() {
  return (
    <div className="w-full">
      {/* HERO SECTION */}
      <section className="relative h-screen flex items-center justify-center bg-black overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div 
            className="w-[120%] h-full absolute top-0 -left-[10%]"
            style={{
              backgroundImage: `url('${heroData.image}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              animation: "panHero 15s linear infinite alternate"
            }}
          ></div>
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        <style>{`
          @keyframes panHero {
            0% { transform: translateX(0); }
            100% { transform: translateX(-5%); }
          }
        `}</style>
        
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-5xl md:text-7xl lg:text-9xl font-bold tracking-tighter mb-6 leading-none">
            {heroData.title.split(",")[0]},
            <br />
            <span className="text-gray-300">{heroData.title.split(",")[1]}</span>
          </h1>
          <p className="text-xl md:text-2xl font-light tracking-wide max-w-2xl mx-auto mb-10">
            {heroData.subtitle}
          </p>
        </div>

        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 animate-bounce text-white">
          <ChevronDown size={32} strokeWidth={1} />
        </div>
      </section>

      {/* BIG TYPOGRAPHY SECTION */}
      <section className="py-32 px-6 lg:px-12 bg-white">
        <div className="container mx-auto max-w-5xl text-center">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter leading-tight mb-12">
            Sistemi progettati per sfidare i confini.
          </h2>
          <p className="text-xl text-gray-600 font-light mb-12 max-w-3xl mx-auto leading-relaxed">
            Trasformiamo la luce nel materiale di costruzione più prezioso. Diamo forma a nuovi spazi abitativi in cui comfort, 
            design minimale e massime prestazioni energetiche si fondono in un'unica, perfetta armonia architettonica.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link to="/chi-siamo" className="group flex items-center gap-2 border-b border-black pb-1 uppercase tracking-widest text-sm font-bold hover:text-[#7dba00] hover:border-[#7dba00] transition-colors">
              La nostra visione <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link to="/prodotti" className="group flex items-center gap-2 border-b border-black pb-1 uppercase tracking-widest text-sm font-bold hover:text-[#7dba00] hover:border-[#7dba00] transition-colors">
              Scopri l'eccellenza <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      {/* REMOVED STATS SECTION */}

      {/* IMAGE ANIMATION SECTION */}
      <section className="py-32 px-6 lg:px-12 bg-white">
        <div className="container mx-auto">
          <div className="mb-20">
            <h2 className="text-4xl md:text-6xl font-bold tracking-tighter mb-6">Sistemi all'avanguardia</h2>
            <p className="text-xl text-gray-600 font-light max-w-2xl">
              Realizziamo serramenti in PVC e Alluminio per incontrare i desideri di ogni cliente e assecondare necessità estetiche e funzionali.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-12">
            {products.slice(0, 3).map((prod) => (
              <Link to="/prodotti" key={prod.id} className="group cursor-pointer">
                <div className="overflow-hidden bg-gray-100 aspect-[4/5] mb-6">
                  <img src={prod.image} alt={prod.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-in-out" />
                </div>
                <h3 className="text-2xl font-bold mb-3 tracking-tight group-hover:text-[#7dba00] transition-colors">{prod.title}</h3>
                <p className="text-gray-600 font-light mb-6">{prod.description}</p>
                <span className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest group-hover:text-[#7dba00] transition-colors">
                  Scopri di più <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="py-32 px-6 lg:px-12 bg-black text-white">
        <div className="container mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter mb-20 text-center">I nostri punti di forza</h2>
          <div className="grid md:grid-cols-3 gap-16">
            {features.map((feat) => (
              <div key={feat.title} className="border-t border-gray-800 hover:border-[#7dba00] transition-colors pt-8 group">
                <h3 className="text-2xl font-bold mb-4 tracking-tight group-hover:text-[#7dba00] transition-colors">{feat.title}</h3>
                <p className="text-gray-400 font-light leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
